import { invoke } from 'lodash';

const formatString = (str: string, variables: any) => {
  let formatted = str;
  for (const key in variables) {
    const value = variables[key];
    formatted = formatted.replace(`{{${key}}}`, value);
  }
  return formatted;
};

export const formatPrice = (p: number) => {
  return p === 0 ? '0.00' : invoke(p, 'toFixed', 2);
};

export default formatString;
